import styled from 'styled-components';
import { BasketUserDetailsStyled } from '../../BasketUserDetailsStyled';
import { rem } from 'polished';

export const BasketUserDetailsOV = styled(BasketUserDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }

    .description {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }

    .reinsurance {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .required-section p {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .input-section {
        &-title {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        input {
            border: 1px solid ${({ theme }) => theme.colors.grey8};
            font-size: ${({ theme }) => theme.fontSizes.h5};

            &.error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &-error {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }
`;
